import { getCurrentInstance } from 'vue';

export const checkLogin = () => {
    if (!localStorage.getItem('token')) {
        console.log("no token found")
        getCurrentInstance().appContext.config.globalProperties.$router.push('/login');
    }
    console.log("token found")
}
